export const API_URL =
  process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.host}`;

export const getWebsocketUrl = (path, params) => {
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const query = new URLSearchParams(params).toString();
return `${protocol}//${window.location.host}${path}?${query}`;
};
